import { colors } from './colors';
export var products = {
  srriBorderRadius: '0px',
  srriLevelTextColor: colors.terciary,
  srriLevelTextColorActive: '#fff',
  srriLevelBackgroundColor: '#fff',
  srriLevelBackgroundColorActive: colors.primary,
  srriLevelBorderColor: colors.primary,
  srriLevelBorderColorActive: colors.primary,
  cardsBackgroundColor: '#ffffff'
};